export const windowSizeCategories = [
    { name: 'Small', maxWidth: 320, maxHeight: 480 },
    { name: 'Medium', maxWidth: 768, maxHeight: 1024 },
    { name: 'Large', maxWidth: Infinity, maxHeight: Infinity }
];